<template lang="pug">
  .container.grid-lg.home
    .home-items
      .h4.text-gray Ordem de Serviços
      div(v-if='loading')
        i.fa.fa-spinner.fa-pulse.fa-3x.fa-fw.text-gray
      .columns(v-else)
        .column.col-3.py-2(v-for='r of ordemServicos')
          .home-item.text-center
            .h3.text-primary {{ r.q }}
            small.text-dark {{ $i18n.t(`enums.db.enum_ordem_servico_situacao.${r.situacao}`) }}
    .home-items
      .h4.text-gray Documentos
      div(v-if='loading')
        i.fa.fa-spinner.fa-pulse.fa-3x.fa-fw.text-gray
      .columns(v-else)
        .column.col-3.py-2(v-for='r of docs')
          .home-item.text-center.tooltip(:data-tooltip='r.valor_total | currency')
            .h3.text-primary {{ r.q }}
            small.text-dark {{ r.situacao }}
</template>

<script>
export default {
  vuex: {
    resumos: {
      state: ['ordemServicos', 'docs'],
      actions: ['fetchOrdemServicos', 'fetchDocs'],
      getters: ['loading'],
    },
  },

  created() {
    if (!this.ordemServicos) {
      this.fetchOrdemServicos()
    }
    if (!this.docs) {
      this.fetchDocs()
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '../styles/_variables.styl'

.home
  .home-items
    margin-top 1rem
    min-height 130px
    .home-item
      border-radius 10px
      height 100%
      padding .8rem
      box-shadow 0 0 10px 1px rgba(0, 0, 0, .1)
</style>
